import  { createRouter, createWebHistory } from 'vue-router'
// import LoginLevel1 from "../components/LoginLevel1.vue";
// import LoginLevel2 from "../components/LoginLevel2.vue";
import HomeLoggedOut from "../views/HomeLoggedOut.vue";
import DashBoard from "../views/DashBoard.vue";
import store from "@/store";
import {log} from "@/composables/useLog";
import Clients from "@/views/Clients.vue";
import ClientInfo from "@/views/ClientInfo.vue";
import EditClientView from "@/views/EditClientView.vue";
import UsersView from "@/views/UsersView.vue";
import TestComponent from "@/views/TestComponent.vue";
import ServicesList from "@/views/ServicesList.vue";
import ClientServicesList from "@/views/ClientServicesList.vue";
import ServicePrices from "@/views/ServicePrices.vue";
import SettingsList from "@/views/SettingsList.vue";
import ImsisList from "@/views/ImsisList.vue";
import ImsiDetails from "@/views/ImsiDetails.vue";
import MsisdnsList from "@/views/MsisdnsList.vue";
import MsisdnDetails from "@/views/MsisdnDetails.vue";
import SimsList from "@/views/SimsList.vue";
import SimDetails from "@/views/SimDetails.vue";
import MsisdnClassSettings from "@/views/MsisdnClassSettings.vue";
import MsisdnPricesSettings from "@/views/MsisdnPricesSettings.vue";
import ImsiGroupsList from "@/views/ImsiGroupsList.vue";
import MsisdnGroupsList from "@/views/MsisdnGroupsList.vue";
import UserDetailsView from "@/views/UserDetailsView.vue";
import AddNewUserView from "@/views/AddNewUserView.vue";
import Reports from "@/views/Reports.vue";
import RolesSettings from "@/views/RolesSettings.vue";
import ServiceTypesSettings from "@/views/ServiceTypesSettings.vue";
import PrepaidSimCards from "@/views/PrepaidSimCards.vue";
import ImsiPricesSettings from "@/views/ImsiPricesSettings.vue";
import DeliveryPricesSettings from "@/views/DeliveryPricesSettings.vue";
import EuroRonRatesSettings from "@/views/EuroRonRatesSettings.vue";
import OrdersList from "@/views/OrdersList.vue";
import TodosList from "@/views/TodosList.vue";
import UserPreferencesSettings from "@/views/UserPreferencesSettings.vue";
import GoodCategoriesList from "@/views/GoodCategoriesList.vue";
import InventoryStatusesList from "@/views/InventoryStatusesList.vue";
import GoodsInventoryList from "@/views/GoodsInventoryList.vue";
import DistributorProductsView from "@/views/DistributorProductsView.vue";
import CommandsView from "@/views/CommandsView.vue";
import CommentsView from "@/views/CommentsView.vue";
import HistoryView from "@/views/HistoryView.vue";
import CommissionsDashboard from "@/views/CommissionsDashboard.vue";
import ReferralLinksView from "@/views/ReferralLinksView.vue";
import RegisterView from "@/views/RegisterView.vue";
import MyProfileView from "@/views/MyProfileView.vue";
import MyMsisdnsView from "@/views/MyMsisdnsView.vue";
import PortabilityRequestsListView from "@/views/PortabilityRequestsListView.vue";
import DunningRulesView from "@/views/DunningRulesView.vue";
import TrafficAlertRulesView from "@/views/TrafficAlertRulesView.vue";
import ImpersonateLogin from "@/views/ImpersonateLogin.vue";
import DashboardTemplatesSettings from "@/views/DashboardTemplatesSettings.vue";
import ClientServicesLimitationsSettings from "@/views/ClientServicesLimitationsSettings.vue";
import ValidityPurchaseOptionsSettings from "@/views/ValidityPurchaseOptionsSettings.vue";
import ValidityOptionLimitsSettings from "@/views/ValidityOptionLimitsSettings.vue";
import DistributorServiceProductsSettings from "@/views/DistributorServiceProductsSettings.vue";
import ServiceMvnoOperationsSettings from "@/views/ServiceMvnoOperationsSettings.vue";
import SettingsParametersView from "@/views/SettingsParametersView.vue";
import DisplaySettings from "@/views/DisplaySettings.vue";
import ServiceQuarantineDurationsSettings from "@/views/ServiceQuarantineDurationsSettings.vue";
import SettingsCategoryView from "@/views/SettingsCategoryView.vue";
import ImsiTypesSettings from "@/views/ImsiTypesSettings.vue";
import NotificationTemplatesSettings from "@/views/NotificationTemplatesSettings.vue";
import HowToGuides from "@/views/HowToGuides.vue";
import PlatformManual from "@/views/PlatformManual.vue";
import LegalTermsView from "@/views/LegalTermsView.vue";
import TrafficReportsView from "@/views/TrafficReportsView.vue"
import SimNetworkServicesView from "@/views/SimNetworkServicesView.vue";
import GdprSearchSettings from "@/views/GdprSearchSettings.vue";
import AdminVeridianImportView from "@/views/AdminVeridianImportView.vue";
import ImsiInventorySettings from "@/views/ImsiInventorySettings.vue";
import MsisdnInventorySettings from "@/views/MsisdnInventorySettings.vue";
import UnderConstruction from "@/views/UnderConstruction.vue";
import HostAccessControlView from "@/views/HostAccessControlView.vue";
import OnboardingView from "@/views/OnboardingView.vue";
import TranslationsView from "@/views/TranslationsView.vue";
import MetaPolicyView from "@/views/MetaPolicyView.vue";
import LandingPage from "@/views/LandingPage.vue";
import DemoView from "@/views/DemoView.vue";
import ClientShellView from "@/views/client/ClientShellView.vue";

const routes = [

  { name: 'home', path: "/", component: LandingPage },
  { name: 'login', path: "/login", component: HomeLoggedOut },
  { name: 'demo', path: "/demo", component: DemoView },
  { name: 'clientHome', path: "/me", component: ClientShellView },
  { name: 'test', path: "/test", component: TestComponent },
  { name: 'dashboard', path: "/dashboard", component: DashBoard },
  { name: 'services', path: "/services", component: ServicesList },
  { name: 'prepaidSimCards', path: "/prepaidSimCards", component: PrepaidSimCards },
  { name: 'userDetails', path: "/user_details", component: UserDetailsView },
  { name: 'settings', path: "/settings", component: SettingsList },
  { name: 'settingsCategory', path: "/settings/:category", component: SettingsCategoryView },
  { name: 'clientServices', path: "/clientServices", component: ClientServicesList },
  { name: 'servicePrices', path: "/prices", component: ServicePrices },
  { name: 'homeLoggedOut', path: "/homeLoggedOut", component: HomeLoggedOut },
  { name: 'clients', path: "/clients", component: Clients },
  { name: 'client', path: '/client', component: ClientInfo},
  { name: 'editClient', path: '/edit-client', component: EditClientView},
  { name: 'imsis', path: '/imsis', component: ImsisList},
  { name: 'msisdnClassSettings', path: '/msisdnClassSettings', component: MsisdnClassSettings},
  { name: 'msisdnPricesSettings', path: '/msisdnPricesSettings', component: MsisdnPricesSettings},
  { name: 'imsi', path: '/imsi/:id', component: ImsiDetails},
  { name: 'msisdns', path: '/msisdns', component: MsisdnsList},
  { name: 'msisdn', path: '/msisdn/:id', component: MsisdnDetails},
  { name: 'imsiGroups', path: '/imsi-groups', component: ImsiGroupsList},
  { name: 'msisdnGroups', path: '/msisdn-groups', component: MsisdnGroupsList},
  { name: 'sims', path: '/sims', component: SimsList},
  { name: 'sim', path: '/sim/:id', component: SimDetails},
  { name: 'sim-network-services', path: '/sim/:id/network-services', component: SimNetworkServicesView},
  { name: 'users', path: "/users", component: UsersView },
  { name: 'addNewUser', path: "/addNewUser", component: AddNewUserView },
  { name: 'products', path: "/products", component: DistributorProductsView },
  { name: 'commands', path: "/commands", component: CommandsView },
  { name: 'comments', path: "/comments", component: CommentsView },
  { name: 'history', path: "/history", component: HistoryView },
  { name: 'trafficReports', path: "/reports/traffic", component: TrafficReportsView },
  { name: 'reports', path: "/reports", component: Reports },
  { name: 'rolesSettings', path: "/rolesSettings", component: RolesSettings },
  { name: 'serviceTypesSettings', path: "/serviceTypesSettings", component: ServiceTypesSettings },
  { name: 'imsiPricesSettings', path: "/imsiPricesSettings", component: ImsiPricesSettings },
  { name: 'deliveryPricesSettings', path: "/deliveryPricesSettings", component: DeliveryPricesSettings },
  { name: 'euroRonRatesSettings', path: "/euroRonRatesSettings", component: EuroRonRatesSettings },
  { name: 'orders', path: "/orders", component: OrdersList },
  { name: 'todosSettings', path: "/todosSettings", component: TodosList },
  { name: 'userPreferencesSettings', path: "/userPreferencesSettings", component: UserPreferencesSettings },
  { name: 'goodCategories', path: "/goodCategories", component: GoodCategoriesList },
  { name: 'inventoryStatuses', path: "/inventoryStatuses", component: InventoryStatusesList },
  { name: 'goodsInventory', path: "/goodsInventory", component: GoodsInventoryList },
  { name: 'financial', path: "/financial", component: HomeLoggedOut },
  { name: 'commissions', path: "/commissions", component: CommissionsDashboard },
  { name: 'referrals', path: "/referrals", component: ReferralLinksView },
  { name: 'register', path: "/register", component: RegisterView },
  { name: 'my-profile', path: "/my-profile", component: MyProfileView },
  { name: 'my-msisdns', path: "/my-msisdns", component: MyMsisdnsView },
  { name: 'portability-requests', path: "/portability-requests", component: PortabilityRequestsListView },
  { name: 'dunning-rules', path: "/dunning-rules", component: DunningRulesView },
  { name: 'traffic-alerts', path: "/traffic-alerts", component: TrafficAlertRulesView },
  { name: 'impersonate', path: "/impersonate", component: ImpersonateLogin },
  { name: 'dashboardTemplatesSettings', path: "/dashboardTemplatesSettings", component: DashboardTemplatesSettings },
  { name: 'serviceLimitationsSettings', path: "/serviceLimitationsSettings", component: ClientServicesLimitationsSettings },
  { name: 'validityPurchaseOptions', path: "/validityPurchaseOptions", component: ValidityPurchaseOptionsSettings },
  { name: 'validityOptionLimits', path: "/validityOptionLimits", component: ValidityOptionLimitsSettings },
  { name: 'distributorServiceProducts', path: "/distributorServiceProducts", component: DistributorServiceProductsSettings },
  { name: 'serviceMvnoOperations', path: "/serviceMvnoOperations", component: ServiceMvnoOperationsSettings },
  { name: 'settingsParameters', path: "/settingsParameters", component: SettingsParametersView },
  { name: 'displaySettings', path: "/settings/display", component: DisplaySettings },
  { name: 'serviceQuarantineDurations', path: "/serviceQuarantineDurations", component: ServiceQuarantineDurationsSettings },
  { name: 'imsiTypesSettings', path: "/imsiTypesSettings", component: ImsiTypesSettings },
  { name: 'notificationTemplatesSettings', path: "/notificationTemplatesSettings", component: NotificationTemplatesSettings },
  { name: 'howto', path: "/howto", component: HowToGuides },
  { name: 'manual', path: "/manual", component: PlatformManual },
  { name: 'legalTerms', path: "/legal/terms", component: LegalTermsView },
  { name: 'gdprSearch', path: "/settings/gdpr-search", component: GdprSearchSettings },
  { name: 'adminVeridianImport', path: "/settings/admin-veridian-import", component: AdminVeridianImportView },
  { name: 'imsiInventory', path: "/imsiInventory", component: ImsiInventorySettings },
  { name: 'msisdnInventory', path: "/msisdnInventory", component: MsisdnInventorySettings },
  { name: 'underConstruction', path: "/under-construction", component: UnderConstruction },
  { name: 'hostAccessControl', path: "/hostAccessControl", component: HostAccessControlView },
  { name: 'onboarding', path: "/onboarding", component: OnboardingView },
  { name: 'translations', path: "/translations", component: TranslationsView },
  { name: 'logout', path: "/logout", component: HomeLoggedOut },
  { name: 'metaPolicy', path: "/meta_policy", component: MetaPolicyView },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  // Routes that don't require authentication
  const publicRoutes = ['/homeLoggedOut', '/login', '/demo', '/register', '/', '/impersonate', '/meta_policy'];

  if (publicRoutes.includes(to.path)) {
    log(`intram pe ruta publica: ${to.path}`)
    next();
  }
  // if (to.path != "/homeLoggedOut"  && !store.getters.isLoggedIn) {
  else if (!store.getters.isLoggedIn) {
    log(`intram in router pe !store.getters.isLoggedIn`)
    next("/login");
  }  else if (store.getters.isLoggedIn==true) {
    // Check if onboarding is needed
    const user = store.getters.getUser;
    if (user?.userClient?.onboarding_completed === false && to.path !== '/onboarding' && to.path !== '/logout') {
      log(`redirect to onboarding - profile not completed`)
      next('/onboarding');
    } else {
      log(`intram in router pe store.getters.isLoggedIn TRUE`)
      next();
    }
  }
});

export default router